export enum LengthTypes {
    Meter,
    MicroMeter,
    MilliMeter,
    CentiMeter,
    DeciMeter,
    DekaMeter,
    HectoMeter,
    KilloMeter,
    Angstrom,
    Inch,
    Feet,
    Yard,
    RodOrPoleOrPerch,
    Chain,
    Furlong,
    Mile,
    Hand,
    Mil,
    CableLength,
    Fathom,
    NauticalLeague,
    NauticalMile
}